var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echartsBox"},[_c('div',{ref:"ciyun1",staticClass:"ciyun1",attrs:{"id":"ciyun1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }